// extracted by mini-css-extract-plugin
export default {"costumeImage":"CostumeSelector_costumeImage__kv+hG"};